import ConsoleError from '@/modules/core/models/errors/ConsoleError'
import Joi from 'joi'

export default Joi.object({
  businessLine: Joi.string().required(),
  businessLineId: Joi.string().required(),
  maxInsurances: Joi.number().integer().min(0).required(),
  maxDays: Joi.number().integer().min(0).required(),
  maxYearsDeparture: Joi.number().integer().min(0).required(),
  maxYearsReturn: Joi.number().integer().min(0).required(),
  stayAbroadTypes: Joi.any().allow(null).optional(),
  hiringMaxAges: Joi.object({
    holderInsured: Joi.object({
      min: Joi.string().required(),
      max: Joi.string().required()
    }).required(),
    holderNotInsured: Joi.object({
      min: Joi.string().required(),
      max: Joi.string().required()
    }).required(),
    insured: Joi.object({
      min: Joi.string().required(),
      max: Joi.string().required()
    }).required()
  }).required(),
  billingCycles: Joi.object({
    monthly: Joi.object({
      id: Joi.string().required(),
      textInFilter: Joi.string().required(),
      textInPrice: Joi.string().required(),
      discountText: Joi.string().allow(''),
      default: Joi.boolean().required()
    }).required(),
    quarterly: Joi.object({
      id: Joi.string().required(),
      textInFilter: Joi.string().required(),
      textInPrice: Joi.string().required(),
      discountText: Joi.string().allow(''),
      default: Joi.boolean().required()
    }).required(),
    semiannual: Joi.object({
      id: Joi.string().required(),
      textInFilter: Joi.string().required(),
      textInPrice: Joi.string().required(),
      discountText: Joi.string().allow(''),
      default: Joi.boolean().required()
    }).required(),
    annual: Joi.object({
      id: Joi.string().required(),
      textInFilter: Joi.string().required(),
      textInPrice: Joi.string().required(),
      discountText: Joi.string().allow(''),
      default: Joi.boolean().required()
    }).required(),
    unique: Joi.object({
      id: Joi.string().required(),
      textInFilter: Joi.string().required(),
      textInPrice: Joi.string().optional().allow(null, ''),
      discountText: Joi.string().allow(''),
      default: Joi.boolean().required()
    }).required()
  }).required(),
  genders: Joi.object({
    female: Joi.object({
      id: Joi.string().required(),
      text: Joi.string().required(),
      default: Joi.boolean().required()
    }).required(),
    male: Joi.object({
      id: Joi.string().required(),
      text: Joi.string().required(),
      default: Joi.boolean().required()
    }).required()
  }).required(),
  houseTypes: Joi.object({
    apartment: Joi.object({
      id: Joi.string().required(),
      text: Joi.string().required(),
      default: Joi.boolean().required()
    }).required(),
    house: Joi.object({
      id: Joi.string().required(),
      text: Joi.string().required(),
      default: Joi.boolean().required()
    }).required()
  }).required(),
  copaymentTypes: Joi.any().allow(null).optional(),
  insuranceTypes: Joi.object({
    business: Joi.object({
      id: Joi.string().required(),
      text: Joi.string().required(),
      default: Joi.boolean().required(),
      disabled: Joi.boolean().required()
    }).required(),
    cruise: Joi.object({
      id: Joi.string().required(),
      text: Joi.string().required(),
      default: Joi.boolean().required(),
      disabled: Joi.boolean().required()
    }).required(),
    several: Joi.object({
      id: Joi.string().required(),
      text: Joi.string().required(),
      default: Joi.boolean().required(),
      disabled: Joi.boolean().required()
    }).required(),
    studyAbroad: Joi.object({
      id: Joi.string().required(),
      text: Joi.string().required(),
      default: Joi.boolean().required(),
      disabled: Joi.boolean().required()
    }).required()
  }).required(),
  destinationTypes: Joi.object({
    spain: Joi.object({
      id: Joi.string().required(),
      text: Joi.string().required(),
      default: Joi.boolean().required(),
      disabled: Joi.boolean().required()
    }).required(),
    europeAndMediterraneanCoastCountries: Joi.object({
      id: Joi.string().required(),
      text: Joi.string().required(),
      default: Joi.boolean().required(),
      disabled: Joi.boolean().required()
    }).required(),
    spainEuropeAndMediterraneanCoastCountries: Joi.object({
      id: Joi.string().required(),
      text: Joi.string().required(),
      default: Joi.boolean().required(),
      disabled: Joi.boolean().required()
    }).optional(),
    restOfTheWorld: Joi.object({
      id: Joi.string().required(),
      text: Joi.string().required(),
      default: Joi.boolean().required(),
      disabled: Joi.boolean().required()
    }).required()
  }).required(),
  paymentTypes: Joi.object({
    card: Joi.object({
      id: Joi.string().required(),
      text: Joi.string().required(),
      default: Joi.boolean().required(),
      disabled: Joi.boolean().required()
    }).required(),
    bizum: Joi.object({
      id: Joi.string().required(),
      text: Joi.string().required(),
      default: Joi.boolean().required(),
      disabled: Joi.boolean().required()
    }).required()
  }).required(),
  tags: Joi.object({
    personalDataAlert: Joi.object({
      label: Joi.string().required(),
      icon: Joi.string().required()
    }).required(),
    contactDataAlert: Joi.object({
      label: Joi.string().required(),
      icon: Joi.string().required()
    }).required(),
    contactDataInsuredAlert: Joi.object({
      label: Joi.string().required(),
      icon: Joi.string().required()
    }).required(),
    allYearAlert: Joi.object({
      label: Joi.string().required(),
      icon: Joi.string().required()
    }).required(),
    europeAndMediterraneanCountriesAlert: Joi.object({
      label: Joi.string().required(),
      icon: Joi.string().required()
    }).required(),
    personalDataInsuredAlert: Joi.object({
      label: Joi.string().required(),
      icon: Joi.string().required()
    }).required(),
    allYearPassedDateAlert: Joi.object({
      label: Joi.string().required(),
      icon: Joi.string().required()
    }).optional()
  }).required()
})
  .error((errors) => {
    const text = `DXP Travel branch configuration - ${errors
      .map((e) => `"${e.local.label}" is required`)
      .join()}`
    console.error(text)
    return new ConsoleError({ message: text })
  })
  .unknown(true)
